import { type ClassValue, clsx } from 'clsx'
import { format } from 'date-fns'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export function countryCodeToFlag(code: string): string {
	const upper = code.toUpperCase()
	if (upper.length !== 2) { return '' }
	return String.fromCodePoint(
		...Array.from(upper).map((c) => 0x1F1E6 - 65 + c.charCodeAt(0)),
	)
}

/** Returns a YYYY-MM-DD string from a Date using the local calendar date. */
export function toLocalDateString(date: Date): string {
	return format(date, 'yyyy-MM-dd')
}

/**
 * Serialises a Date to an ISO 8601 string with the local timezone offset.
 * e.g. Helsinki midnight → "2026-04-13T00:00:00+02:00"
 * Use this for sending dates to the backend so the stored UTC value
 * correctly reflects the user's local calendar date.
 */
export function toLocalISOString(date: Date): string {
	return format(date, "yyyy-MM-dd'T'HH:mm:ssxxx")
}

export function parseNoteContent(content: string | null | undefined): string | null {
	if (!content) { return null }

	const trimmed = content.trim()
	if (!trimmed.startsWith('[')) {
		return content
	}

	try {
		const parsed = JSON.parse(trimmed)
		if (Array.isArray(parsed)) {
			const text = parsed
				.map((block) => {
					if (block.content && Array.isArray(block.content)) {
						return block.content
							.map((item: { text?: string }) => item.text ?? '')
							.join('')
					}
					return ''
				})
				.filter(Boolean)
				.join('\n')

			return text || null
		}
	} catch {
		// Not valid JSON, treat as plain text
	}

	return content
}
